"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable max-len */

var TrendingDown = function TrendingDown() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trending_down_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.741 5.573l3.887 3.885c0.386,-0.252 1.867,-1.939 2.139,-2.077l2.527 2.544 -1.181 1.206c0.383,0.041 2.571,0.016 3.128,0.016 0.003,-0.891 0.035,-2.312 0.004,-3.14l-1.185 1.175c-0.161,-0.081 -3.089,-3.002 -3.284,-3.282 -0.256,0.105 -1.792,1.829 -2.143,2.073 -0.199,-0.094 -3.092,-3.048 -3.164,-3.127 -0.136,0.099 -0.629,0.592 -0.728,0.727z",
    fill: "#D97F00"
  })));
};
var _default = TrendingDown;
exports.default = _default;